'use client';

import { Feedback } from '@savvy-kit/patterns/feedback';
import { isNil } from 'es-toolkit';

type Props = {
  readonly outstandingCount: number | null | undefined;
};

// Null and 0 are different answers: null means the household has no service
// schedule at all, 0 means it has one and nothing is due.
export function ServiceCalendarStatus({ outstandingCount }: Props) {
  if (isNil(outstandingCount)) return <span className="text-secondary">Not set up</span>;
  if (outstandingCount === 0) return <span className="text-secondary">No items due</span>;

  return (
    <Feedback variant="warning" className="text-sm">
      {outstandingCount} services due
    </Feedback>
  );
}
